import React from 'react';
import classNames from 'classnames';
import { getFormattedDate } from 'dateUtils';
import { IconProp } from 'models/Icon';

import './ReportDetails.styles.scss';
import './ReportDetails.styles.responsive.scss';

type ReportDetailsProps = {
  className?: string;
  text: React.ReactNode;
  createdAt: Date;
  dateFormat: string;
  icon: IconProp;
};

const ReportDetails: React.FC<ReportDetailsProps> = (props) => {
  const { className, text, createdAt, dateFormat, icon: Icon } = props;

  const classes = classNames('report-details', className);

  const formattedDate = getFormattedDate(new Date(createdAt), dateFormat);

  return (
    <div className={classes}>
      <div className="report-details__main-info">
        <Icon />
        <div>{text}</div>
      </div>
      <div className="report-details__additional-info">{formattedDate}</div>
    </div>
  );
};

export default ReportDetails;
